import React from 'react'
import { Alert, Button, Icon, Modal, Progress, Spin } from 'antd'

import { canEmbedTimelineEditor } from '../../utils/timelineEditor'
import './AdvancedVideoEditorModal.scss'

const AdvancedVideoEditorModal = ({
  visible,
  editorUrl,
  loading,
  error,
  statusText,
  progress,
  onClose
}) => {
  const canEmbed = canEmbedTimelineEditor(editorUrl)

  return (
    <Modal
      visible={visible}
      title="Advanced Video Editor"
      width="calc(100vw - 48px)"
      style={{ top: 24, paddingBottom: 0 }}
      className="advanced-editor-modal"
      wrapClassName="advanced-editor-modal-wrap"
      footer={null}
      onCancel={onClose}
      destroyOnClose
      maskClosable={false}
      bodyStyle={{ padding: 0 }}
    >
      {editorUrl && canEmbed ? (
        <iframe
          title="Advanced video editor"
          src={editorUrl}
          className="advanced-editor-frame"
          allow="fullscreen; clipboard-read; clipboard-write; autoplay"
          allowFullScreen
        />
      ) : editorUrl ? (
        <div className="advanced-editor-status advanced-editor-status--blocked">
          <span className="advanced-editor-status__icon">
            <Icon type="export" />
          </span>
          <Alert
            type="warning"
            showIcon
            message="The editor cannot be embedded in this environment"
            description="The timeline editor's security policy does not allow this app origin to display it inside an iframe. Open it in a new tab to continue."
          />
          <Button
            type="primary"
            icon="select"
            href={editorUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Timeline Editor
          </Button>
        </div>
      ) : loading ? (
        <div className="advanced-editor-status">
          <Spin />
          <span>{statusText || 'Preparing advanced editor...'}</span>
          <Progress
            percent={Math.max(0, Math.min(100, progress || 0))}
            showInfo={false}
            strokeWidth={6}
          />
        </div>
      ) : error ? (
        <div className="advanced-editor-status">
          <Alert
            type="error"
            showIcon
            message="Advanced editor request failed"
            description={error}
          />
        </div>
      ) : (
        <div className="advanced-editor-status">
          <Alert
            type="info"
            showIcon
            message="Advanced editor unavailable"
            description="The editor URL could not be loaded."
          />
        </div>
      )}
    </Modal>
  )
}

export default AdvancedVideoEditorModal
